import React from "react";
import { TextField } from "@mui/material";
import { TextQuestion } from "../../types";

interface TextQuestionProps {
  question: TextQuestion;
  value: string;
  onChange: (value: string) => void;
}

export const TextQuestionField: React.FC<TextQuestionProps> = ({
  question,
  value,
  onChange,
}) => (
  <TextField
    fullWidth
    multiline
    minRows={3}
    placeholder={question.placeholder}
    value={value}
    onChange={(event) => onChange(event.target.value)}
  />
);
